import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static targets = ["body", "bodyHtml"]

  connect() {
    // Set up form submit handler
    this.element.addEventListener('submit', this.generateHtml.bind(this))
  }

  cancel(event) {
    event.preventDefault();

    // Inline replies/forwards live in a turbo-frame; clear it.
    const frame = this.element.closest('turbo-frame');
    if (frame) {
      frame.innerHTML = '';
      return;
    }

    // The standalone compose form lives in a modal; close it.
    const modalEl = this.element.closest('.modal');
    if (modalEl) {
      bootstrap.Modal.getOrCreateInstance(modalEl).hide();
    }
  }

  // Generate HTML from plain text body
  generateHtml(event) {
    // Only generate if body_html is empty
    if (this.bodyHtmlTarget.value) return

    const text = this.bodyTarget.value
    const escaped = text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
    
    const html = '<div dir="ltr">' + escaped.replace(/\n/g, '<br>') + '</div>'
    this.bodyHtmlTarget.value = html
  }
}